import { Injectable } from '@angular/core';
import { StaysWidget } from '@com-delta-idp/mnx-sitewide-header-ui';
import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { StaysLabels } from '../../models/interface/booking-stays/stays-interface';

@Injectable({ providedIn: 'root' })
export class StaysLabelsAdapter {
  getLabels(aem: HeaderFooterMachCore): StaysWidget['labels'] {
    const labels = aem?.header?.book?.stays?.labels;
    return {
      ...this.getButtonLabels(labels),
      ...this.getErrorLabels(labels)
    };
  }

  private getButtonLabels(labels: StaysLabels): {
    findButton: string;
    viewSearchOptions: string;
    startDate: string;
    endDate: string;
  } {
    return {
      ...this.getActionLabels(labels),
      ...this.getDateLabels(labels)
    };
  }

  private getActionLabels(labels: StaysLabels) {
    return {
      findButton: labels?.findButton ?? '',
      viewSearchOptions: labels?.viewSearchOptions ?? ''
    };
  }

  private getDateLabels(labels: StaysLabels) {
    return {
      startDate: labels?.startDate ?? '',
      endDate: labels?.endDate ?? ''
    };
  }

  private getErrorLabels(labels: StaysLabels): {
    errorMessage: string;
    destinationErrorLabel: string;
    datesAreRequiredErrorLabel: string;
    maxDatesErrorLabel: string;
    tooFewPeopleErrorLabel: string;
    tooFewRoomsErrorLabel: string;
  } {
    return {
      errorMessage: labels?.errorMessage ?? '',
      ...this.getValidationErrorLabels(labels)
    };
  }

  private getValidationErrorLabels(labels: StaysLabels) {
    return {
      ...this.getFormErrorLabels(labels),
      ...this.getRoomErrorLabels(labels)
    };
  }

  private getFormErrorLabels(labels: StaysLabels) {
    return {
      destinationErrorLabel: labels?.destinationErrorLabel ?? '',
      datesAreRequiredErrorLabel: labels?.datesAreRequiredErrorLabel ?? '',
      maxDatesErrorLabel: labels?.maxDatesErrorLabel ?? ''
    };
  }

  private getRoomErrorLabels(labels: StaysLabels) {
    return {
      tooFewPeopleErrorLabel: labels?.tooFewPeopleErrorLabel ?? '',
      tooFewRoomsErrorLabel: labels?.tooFewRoomsErrorLabel ?? ''
    };
  }
}
